import React, { Fragment } from "react";
import PropTypes from "prop-types";

const RestrictionListView = ({ restrictionList }) => {

  return (
    <ul style={{ padding: "0px 20px", listStyleType: "none", fontSize: "14px" }}>
      {restrictionList.map((restrictionItem, index) => (
        <li key={index} style={{ paddingBottom: "10px" }}>
          <sup style={{ color: "#f5ab35", marginLeft: "-4px" }}>*</sup>
          <span style={{ fontFamily: "AvenirNextMedium", textTransform: "capitalize" }}>{restrictionItem.restrictionType} </span>
          {restrictionItem.streamlinedCode
            &&
            <span style={{ fontFamily: "AvenirNextMedium" }}>Code Required </span>
          }
          <span>{restrictionItem.streamlinedCode}</span>
          {restrictionItem.firstSentence
            &&
            <Fragment>
              <br />
              <span>{restrictionItem.firstSentence}</span>
            </Fragment>
          }
          {restrictionItem.clinicalCriteria
            &&
            <Fragment>
              <br />
              <span style={{ fontFamily: "AvenirNextMedium", fontWeight: "600" }}>Clinical Criteria: </span>
              <span dangerouslySetInnerHTML={{ __html: restrictionItem.clinicalCriteria }}></span>
            </Fragment>
          }
          {restrictionItem.populationCriteria
            &&
            <Fragment>
              <br />
              <span style={{ fontFamily: "AvenirNextMedium", fontWeight: "600" }}>Population Criteria: </span>
              <span dangerouslySetInnerHTML={{ __html: restrictionItem.populationCriteria }}></span>
            </Fragment>
          }

        </li>
      ))

      }
    </ul>
  )
}

RestrictionListView.propTypes = {
  restrictionList: PropTypes.array,
}

export default RestrictionListView;